module.exports = __webpack_public_path__ + "img/6.2fc1466e.svg";